import { View } from "binder"
import { PropertyBodyCodeEditorViewModel } from "./propertyBodyCodeEditor-viewModel"
import * as monaco from 'monaco-editor'
import { DataModelBuilderViewModel, DataModelClass, Method, Property } from "../dataModelBuilder-viewModel";
import { IPropertyTypeVisitor, PropertyType, ServerSideDataLoaderType, VoidType, BooleanType, IntegerType, FloatType, StringType, ListType, ClassType, KnownClassType, DateType } from "../../structure";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class PropertyBodyCodeEditorView extends View<PropertyBodyCodeEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-3C6743D9-50E5-495E-92A4-9F2F21D16395"
    }
    loadHtml(): string {
        let element = require('./propertyBodyCodeEditor.html').default;
        let style = require('./propertyBodyCodeEditor.less');
        return element;
    }
    constructor() {
        super();

        if(PropertyBodyCodeEditorView._executionIndex==null){
            PropertyBodyCodeEditorView._executionIndex=0;
        }
        PropertyBodyCodeEditorView._executionIndex++;
        this.isRan = false;
        this.Rendered = false;
        this.hasData = false;

    }
    public Rendered:boolean;
    public hasData : boolean;
    public isRan:boolean;
    public static _executionIndex:number=0;
    public static currentModel:any;
    public set model(v: DataModelBuilderViewModel) { this._model = v; } public get model(): DataModelBuilderViewModel { return this._model;} private _model: DataModelBuilderViewModel;
    public set currentClass(v: DataModelClass) { this._currentClass = v; } public get currentClass(): DataModelClass { return this._currentClass;} private _currentClass: DataModelClass;
    public set currentProperty(v: Property) { this._currentProperty = v; } public get currentProperty(): Property { return this._currentProperty;} private _currentProperty: Property;
    private editor;


    confirm(){
        let code:string = this.editor?.getValue();
        let removeStart = code.split('//--Pre Code Starts From Here--')[1];
        let buffer = removeStart.split('//--Pre Code Ends Here--');
        let preCode = buffer[0].trim();
        let postCode = buffer[1].split('//--Post Code Starts From Here--')[1].split("//--Post Code Ends Here--")[0].trim();
        this.dataContext.confirm(preCode,postCode);
        this.editor?.dispose();
    }
    close(){
        this.editor?.dispose();
        this.dataContext.close();
    }

    public onRenderCompleted(): any {
        this.Rendered = true;
        this.Run();
    }
    public onDataContextSet():any{
        this.hasData = true;
        this.Run();
    }
    private getCodeForProperty(p:Property){
        let resolver = new typeNameResolver();
        let typeName =resolver.getName(p.type);
        let preCode:string
        try{
            preCode = p.preBody[0].Code;
        }catch(ex){

        }
        finally{
            if(stringIsNullOrEmpty(preCode)){
                preCode = 'return true;';
            }
        }
        let postCode:string
        try{
            postCode = p.postBody[0].Code;
        }catch(ex){

        }
        finally{
            if(stringIsNullOrEmpty(postCode)){
                postCode = '';
            }
        }
        let result = `\tpre(oldValue:${typeName},newValue:${typeName}){
\t\t//--Pre Code Starts From Here--
\t\t${preCode}
\t\t//--Pre Code Ends Here--
\t}
\tpost(oldValue:${typeName},newValue:${typeName}){
\t\t//--Post Code Starts From Here--
\t\t${postCode}
\t\t//--Post Code Ends Here--
\t}`;
        return result;    
    }
    Run(){
        if(this.hasData==false)
            return;
        if(this.Rendered==false)
            return;
        if(this.isRan==true)
            return;
        this.isRan = true;
        setTimeout(()=>{
            let typeing = new typingGenerator().getTypings(this.model);
            let code = `class _TEST_ extends ${this.currentClass.name} {
\t${this.getCodeForProperty(this.currentProperty)}
}`
            monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
                noSemanticValidation: true,
                noSyntaxValidation: false
            });
    
            monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
                target: monaco.languages.typescript.ScriptTarget.ES5,
                allowNonTsExtensions: true
            });
            let libUri = `ts:filename/_propertybodycreator_${PropertyBodyCodeEditorView._executionIndex}.d.ts`;
            if(PropertyBodyCodeEditorView.currentModel!=null){
                PropertyBodyCodeEditorView.currentModel.dispose();
            }
            monaco.languages.typescript.javascriptDefaults.addExtraLib(typeing, libUri);
            PropertyBodyCodeEditorView.currentModel = monaco.editor.createModel(typeing, 'typescript', monaco.Uri.parse(libUri));
    
            let element2 = <HTMLElement>this.firstlevelElement.querySelector('#container');
            this.editor = monaco.editor.create(element2, {
                value: code,
                language: 'javascript'
            });
        },1)
    }
}



class typingGenerator{
    public getTypings(model:DataModelBuilderViewModel) : string{
        this.result = [];
        this.typeNameResolver = new typeNameResolver();
        this.result.push(`
declare class DataLoader{
    refresh():Promise<void>;
    refreshExport(type:string):Promise<void>;
}
declare class BaseType{
    OnLoad();
    StringIsNullOrEmpty(value:string):boolean;
    __GetClassName__():string;
    __CreatePaginationInfo(current:number,total:number):any;
    __CreateChildInstanceFromTypeName(typeName:string):any;
    __CreateComboBox(isMultiSelect:boolean,searchable:boolean):ViewModel;
    async __ShowPopup(viewModel:any,templateSelector:string,width?:string,height?:string):Promise<any>;
    async __CallServer(address:string,parameter:any):Promise<any>;
    async __PrintReport(reportId:string,data:any,copyCount:number);
    __ExportCsv(fileName:string,exportingData:any[]);
    __ConvertToPersianDate(d:moment.Moment,format?:string):string;

    closePopup(result?: any);

    async requestRefreshWindow();
    async messageBox(message:string,title:string,type:"success"|"warning"|"danger"|"dark",...buttons:{title:string,className:"danger"|"info"|"success"|"primary"|"secondary"|"warning",resultCode:string}[]):Promise<string>;
    async messageBoxDangerYesNo(message:string,title:string);
    async messageBoxWarningYesNo(message:string,title:string);
    async messageBoxSuccessYesNo(message:string,title:string);
    async messageBoxConfirmSuccess(message:string,title:string);
    async messageBoxConfirmWarning(message:string,title:string);
}
declare class ObservableArray<T> extends Array<T>{
    update(...children:T[]): any;
    insertAt(index:number,...items:T[]);
    clear();
    remove(...list: T[]): any;
}`)
        model.classes.forEach(x=>{
            this.createForClass(x);
        })
        return this.result.join('\r\n');
    } 
    private typeNameResolver : typeNameResolver;
    private result :string[];
    private createForClass(cls:DataModelClass){
        this.result.push(`declare class ${cls.name} extends BaseType{`);
        cls.properties.forEach(x=>this.createProperty(x));
        cls.methods.forEach(x=>this.createMethod(x));
        this.result.push("}");
    } 
    private createProperty(p : Property){
        this.result.push(`  ${p.name}:${this.typeNameResolver.getName(p.type)};`)
    }
    private createMethod(p : Method){
        let pre = '';
        let returnType = this.typeNameResolver.getName(p.returnType);
        if(p.isAsync){
            pre='async ';
            returnType=`Promise<${returnType}>`;
        }
        this.result.push(`  ${pre}${p.name}(${p.arguments.map(x=>`${x.name}:${this.typeNameResolver.getName(x.type)}`)}):${returnType}`)
    }
}

class typeNameResolver implements IPropertyTypeVisitor {
    getName(type:PropertyType):string{
        return type.Accept(this,null);
    }    

    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return 'DataLoader';
    }
    visitVoidType(arg0: VoidType, parameter: any) {
        return 'void';
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return 'boolean';
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        return 'number';
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return 'number';
    }
    visitStringType(arg0: StringType, parameter: any) {
        return 'string';
    }
    visitListType(arg0: ListType, parameter: any) {
        return `ObservableArray<${this.getName(arg0.OfType)}>`;
    }
    visitClassType(arg0: ClassType, parameter: any) {
        return 'any';
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return arg0.ForClass.name;
    }
    visitDateType(arg0: DateType, parameter: any) {
        return "moment.Moment";
    }

}

